import { TradingFormState } from '../../trading-form/trading-form.types';

export const timeframes = ['1m', '5m', '15m', '30m', '1h', '4h', '1d', '1w'];

const defaultTradingWindowStartDate = undefined;
// dayjs(
//   "2024-11-08T00:00:00.000Z"
// ).toISOString();
const defaultTradingWindowEndDate = undefined;
// dayjs(
//   "2024-11-12T16:00:00.000Z"
// ).toISOString();

export const defaultBacktestingDataState: TradingFormState = {
  marketConfig: {
    tradingMode: 'BACKTESTING',
    exchangeId: 'BYBIT',
    symbol: 'BTCUSDT',
    file: undefined,
    simulation: false,
    useExchangeData: false,
    testnet: true
  },
  positionManagementConfig: {
    positionSize: 10000,
    commissionPercent: 0.1,
    stopLoss: true,
    trailingStop: false,
    trailingStopPercent: 5,
    stopLossPercent: 5,
    scalping: true,
    leverage: 10,
    takeProfitLevels: [],
    scaleIn: {
      enabled: true,
      addSize: 10000,
      onlyInProfit: true
    }
  },
  tradingScheduleConfig: {
    trade: true,
    tradingWindowStart: defaultTradingWindowStartDate,
    tradingWindowEnd: defaultTradingWindowEndDate
  },
  timeframes: [
    {
      timeframe: '4h',
      indicators: [],
      strategy: undefined
    }
  ]
};

export const defaultLiveDataState: TradingFormState = {
  marketConfig: {
    tradingMode: 'LIVE',
    exchangeId: 'BYBIT',
    symbol: 'ETHUSDT',
    testnet: true
  },
  positionManagementConfig: {
    positionSize: 10000,
    stopLoss: true,
    trailingStop: false,
    trailingStopPercent: 5,
    scalping: true,
    stopLossPercent: 5,
    leverage: 10,
    takeProfitLevels: [],
    scaleIn: {
      enabled: true,
      addSize: 10000,
      onlyInProfit: true
    }
  },
  tradingScheduleConfig: {
    trade: false,
    tradingWindowStart: defaultTradingWindowStartDate,
    tradingWindowEnd: defaultTradingWindowEndDate
  },
  timeframes: [
    // {
    //   timeframe: '4h',
    //   indicators: [],
    //   strategy: undefined
    // }
  ]
};
